import { render, staticRenderFns } from "./OperatorProcessBOM.vue?vue&type=template&id=1618d8da&"
import script from "./OperatorProcessBOM.vue?vue&type=script&lang=js&"
export * from "./OperatorProcessBOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports